const scripting = {
  packagesT: {
    zh: 'Packages',
    en: 'Packages',
    pu: 'Pacotes'
  },
  searchPackages: {
    zh: 'Search packages',
    en: 'Search packages',
    pu: 'Pesquisar pacotes'
  },
  address: {
    zh: 'Address',
    en: 'Address',
    pu: 'Endereço'
  },
  area: {
    zh: 'Area',
    en: 'Area',
    pu: 'Área'
  },
  city: {
    zh: 'City',
    en: 'City',
    pu: 'Cidade'
  },
  houseNumber: {
    zh: 'House number',
    en: 'House number',
    pu: 'Número'
  },
  email: {
    zh: 'Email',
    en: 'Email',
    pu: 'Email'
  },
  package: {
    zh: '包裹',
    en: 'Package',
    pu: 'Pacotes'
  },
  mobile: {
    zh: 'Mobile',
    en: 'Mobile',
    pu: 'Celular'
  },
  name: {
    zh: 'Name',
    en: 'Name',
    pu: 'Nome'
  },
  neighborhood: {
    zh: 'Neighborhood',
    en: 'Neighborhood',
    pu: 'Bairro'
  },
  phone: {
    zh: 'Phone',
    en: 'Phone',
    pu: 'Telefone'
  },
  street: {
    zh: 'Street',
    en: 'Street',
    pu: 'Rua'
  },
  generatingPackages: {
    zh: 'Generating packages',
    en: 'Generating packages',
    pu: 'Gerando pacotes'
  },
  equipment: {
    zh: 'Equipment',
    en: 'Equipment',
    pu: 'Equipamento'
  },
  zipCode: {
    zh: 'Zip code',
    en: 'Zip code',
    pu: 'CEP'
  },
  send: {
    zh: 'Send',
    en: 'Send',
    pu: 'Enviar'
  },
  successfullyCreated: {
    zh: 'Successfully Created',
    en: 'Successfully Created',
    pu: 'Criado com sucesso'
  },
  driver: {
    zh: 'Driver',
    en: 'Driver',
    pu: 'Motorista'
  },
  createDriver: {
    zh: 'Create driver',
    en: 'Create driver',
    pu: 'Criar motorista'
  },
  createOrder: {
    zh: 'Create order',
    en: 'Create order',
    pu: 'Criar ordem'
  },
  createEquipment: {
    zh: 'Create equipment',
    en: 'Create equipment',
    pu: 'Criar equipamento'
  },
  createRoute: {
    zh: 'Create route',
    en: 'Create route',
    pu: 'Criar Rota'
  },
  createVehicle: {
    zh: 'Create vehicle',
    en: 'Create vehicle',
    pu: 'Criar veículo'
  },
  action: {
    zh: 'Action',
    en: 'Action',
    pu: 'Ações'
  },
  edit: {
    zh: 'Edit',
    en: 'Edit',
    pu: 'Editar'
  },
  delete: {
    zh: 'Delete',
    en: 'Delete',
    pu: 'Excluir'
  },
  editingDriver: {
    zh: 'Editing driver',
    en: 'Editing driver',
    pu: 'Editar motorista'
  },
  editingEquipment: {
    zh: 'Editing equipment',
    en: 'Editing equipment',
    pu: 'Editar equipamento'
  },
  editingVehicle: {
    zh: 'Editing vehicle',
    en: 'Editing vehicle',
    pu: 'Editar veículo'
  },
  driverLicense: {
    zh: 'Driver license',
    en: 'Driver license',
    pu: 'CNH'
  },
  scoreLicense: {
    zh: 'Score license',
    en: 'Score license',
    pu: 'Pontuação da CNH'
  },
  scoreDriver: {
    zh: 'Driver score',
    en: 'Driver score',
    pu: 'Pontos do motorista'
  },
  licenseType: {
    zh: 'License type',
    en: 'License type',
    pu: 'Tipo da CNH'
  },
  licenseValidate: {
    zh: 'License validate',
    en: 'License validate',
    pu: 'Validade da CNH'
  },
  outsourced: {
    zh: 'Outsourced',
    en: 'Outsourced',
    pu: 'Motorista terceirizado'
  },
  creatingDriver: {
    zh: 'Creating driver',
    en: 'Creating driver',
    pu: 'Criando motorista'
  },
  creatingRoute: {
    zh: 'Creating route',
    en: 'Creating route',
    pu: 'Criando rota'
  },
  creatingOrder: {
    zh: 'Creating order',
    en: 'Creating order',
    pu: 'Criando ordem'
  },
  creatingEquipment: {
    zh: 'Creating equipment',
    en: 'Creating equipment',
    pu: 'Criando equipamento'
  },
  creatingVehicle: {
    zh: 'Creating vehicle',
    en: 'Creating vehicle',
    pu: 'Criando veículo'
  },
  driverDocument: {
    zh: 'Driver document',
    en: 'Driver document',
    pu: 'Documento do motorista'
  },
  vehicle: {
    zh: 'Vehicle',
    en: 'Vehicle',
    pu: 'Veículo'
  },
  created: {
    zh: 'Created',
    en: 'Created',
    pu: 'Criado'
  },
  licensePlate: {
    zh: 'License Plate',
    en: 'License Plate',
    pu: 'Placa do veículo'
  },
  route: {
    zh: 'Route',
    en: 'Route',
    pu: 'Rota'
  },
  deliveryStatus: {
    zh: 'Delivery status',
    en: 'Delivery status',
    pu: 'Status de entrega'
  },
  order: {
    zh: 'Order',
    en: 'Order',
    pu: 'Ordem'
  },
  customer: {
    zh: 'Customer',
    en: 'Customer',
    pu: 'Cliente'
  },
  merchant: {
    zh: 'Merchant',
    en: 'Merchant',
    pu: 'Mercante'
  },
  collectionsPoints: {
    zh: 'Collections points',
    en: 'Collections points',
    pu: 'Pontos de coleta'
  },
  deliverysPoints: {
    zh: 'Deliverys points',
    en: 'Deliverys points',
    pu: 'Pontos de entrega'
  },
  print: {
    zh: 'Print',
    en: 'Print',
    pu: 'Imprimir'
  },
  addLine: {
    zh: 'Add line',
    en: 'Add line',
    pu: 'Adionar linha'
  },
  cancel: {
    zh: 'Cancel',
    en: 'Cancel',
    pu: 'Cancelar'
  },
  documentation: {
    zh: 'Documentation',
    en: 'Documentation',
    pu: 'Documentação'
  },
  trailerPlate: {
    zh: 'Trailer plate',
    en: 'Trailer plate',
    pu: 'Placa da carreta'
  },
  model: {
    zh: 'Model',
    en: 'Model',
    pu: 'Modelo'
  },
  brand: {
    zh: 'Brand',
    en: 'Brand',
    pu: 'Marca'
  },
  capacity: {
    zh: 'Capacity',
    en: 'Capacity',
    pu: 'Capacidade'
  },
  type: {
    zh: 'Type',
    en: 'Type',
    pu: 'Tipo'
  },
  state: {
    zh: 'State',
    en: 'State',
    pu: 'Estado'
  },
  trackerCompanyCode: {
    zh: 'Tracker company code',
    en: 'Tracker company code',
    pu: 'Código da empresa de rastreio'
  },
  trackerCompany: {
    zh: 'Tracker company',
    en: 'Tracker company',
    pu: 'Empresa de rastreio'
  },
  idRoute: {
    zh: 'Id route',
    en: 'Id route',
    pu: 'Id rota'
  },
  merchantCode: {
    zh: 'Merchant code',
    en: 'Merchant code',
    pu: 'Código do mercante'
  },
  merchantName: {
    zh: 'Merchant name',
    en: 'Merchant name',
    pu: 'Nome do mercante'
  },
  collectType: {
    zh: 'Collect type',
    en: 'Collect type',
    pu: 'Tipo de coleta'
  },
  count: {
    zh: 'Count',
    en: 'Count',
    pu: 'Quantidade'
  },
  operationSuccess: {
    zh: 'Successfully performed operation!',
    en: 'Successfully performed operation!',
    pu: 'Operação feita com sucesso!'
  },
  nameDriverPlaceholder: {
    zh: 'Driver name',
    en: 'Driver name',
    pu: 'Nome do motorista'
  },
  phoneDriverPlaceholder: {
    zh: "Driver's phone",
    en: "driver's phone",
    pu: 'Telefone do motorista'
  },
  cpfDriverPlaceholder: {
    zh: "Driver's CPF",
    en: "driver's CPF",
    pu: 'CPF do motorista'
  },
  licenseDriverPlaceholder: {
    zh: "Driver's license",
    en: "driver's license",
    pu: 'CNH do motorista'
  },
  streetDriverPlaceholder: {
    zh: "Driver's street",
    en: "driver's street",
    pu: 'Rua do motorista'
  },
  houseNumberPlaceholder: {
    zh: 'House number',
    en: 'House number',
    pu: 'Número da residência'
  },
  zipCodePlaceholder: {
    zh: 'Enter zip code',
    en: 'Enter zip code',
    pu: 'Digite CEP do motorista'
  },
  pointsLicensePlaceholder: {
    zh: 'Enter the score on the license',
    en: 'Enter the score on the license',
    pu: 'Digite os pontos na CNH'
  },
  pointsDriverPlaceholder: {
    zh: 'Enter driver score',
    en: 'Enter driver score',
    pu: 'Digite os pontos do motorista'
  },
  licenseTypePlaceholder: {
    zh: 'Enter the type of license',
    en: 'Enter the type of license',
    pu: 'Digite o tipo de CNH'
  },
  validatyLicensePlaceholder: {
    zh: 'Enter the validity of the driving license',
    en: 'Enter the validity of the driving license',
    pu: 'Digite a validade da CNH'
  },
  vehicleDocumentationPlaceholder: {
    zh: 'Vehicle documentation',
    en: 'Vehicle documentation',
    pu: 'Documentação do veículo'
  },
  numberPlatePlaceholder: {
    zh: 'Enter the license plate number',
    en: 'Enter the license plate number',
    pu: 'Digite o número da placa'
  },
  numberPlateTrailerPlaceholder: {
    zh: 'Enter the license plate',
    en: 'Enter the license plate',
    pu: 'Digite a placa da carreta'
  },
  rntrcCodePlaceholder: {
    zh: 'RNTRC code',
    en: 'RNTRC code',
    pu: 'Código RNTRC'
  },
  carBrandPlaceholder: {
    zh: 'Vehicle brand',
    en: 'Vehicle brand',
    pu: 'Marca do veículo'
  },
  carModelPlaceholder: {
    zh: 'Vehicle model',
    en: 'Vehicle model',
    pu: 'Modelo do veículo'
  },
  batteryCapacityPlaceholder: {
    zh: 'Battery capacity',
    en: 'Battery capacity',
    pu: 'Capacidade de carga'
  },
  typeVehiclePlaceholder: {
    zh: 'Type vehice',
    en: 'Type vehice',
    pu: 'Tipo de veículo'
  },
  trackingCompanyPlaceholder: {
    zh: 'Enter tracking company',
    en: 'Enter tracking company',
    pu: 'Digite a empresa de rastreio'
  },
  codeTrackingCompanyPlaceholder: {
    zh: 'Enter tracking company code',
    en: 'Enter tracking company code',
    pu: 'Digite o código da empresa de rastreio'
  },
  selectedStatePlaceholder: {
    zh: 'Enter the state',
    en: 'Enter the state',
    pu: 'Digite o estado'
  },
  enterUsernamePlaceholder: {
    zh: 'Enter username',
    en: 'Enter username',
    pu: 'Digite o nome do usuário'
  },
  document: {
    zh: 'Document',
    en: 'Document',
    pu: 'Documento'
  },
  country: {
    zh: 'Country',
    en: 'Country',
    pu: 'País'
  },
  labelOutsourced: {
    zh: 'Outsourced',
    en: 'Outsourced',
    pu: 'Tercerizado'
  },
  printReturnCode: {
    zh: '打印退件码',
    en: 'Print Return Code',
    pu: 'Imprimir Código de Devolução'
  },
  generateReturnCode: {
    zh: '生成退件码',
    en: 'Generate Return Code',
    pu: 'Gerar Código de Devolução'
  },
  nextStationHub: {
    zh: '下一站网点',
    en: 'Next Station Hub',
    pu: 'Próximo Centro de Distribuição'
  },
  returnCode: {
    zh: '退件码',
    en: 'Return Code',
    pu: 'Código de Devolução'
  },
  expiryTime: {
    zh: '有效期截止时间',
    en: 'Expiry Time',
    pu: 'Data de Validade'
  },
  noAvailableReturnCode: {
    zh: '该车辆没有可使用退件码',
    en: 'No Available Return Code for This Vehicle',
    pu: 'Nenhum Código de Devolução Disponível para Este Veículo'
  },
  returnCodeList: {
    zh: '退件码清单',
    en: 'Return Code List',
    pu: 'Lista de Códigos de Devolução'
  },
  exportLatestRecords: {
    zh: '导出最新记录',
    en: 'Export Latest Records',
    pu: 'Exportar Registros Mais Recentes'
  },
  batchReviewLimit: {
    zh: '一次最多可以审10条数据',
    en: 'Maximum 10 data entries per review',
    pu: 'Máximo de 10 entradas de dados por revisão'
  },
  confirmAuditPass: {
    zh: '确认通过该确认单的审核吗?',
    en: 'Confirm to approve this confirmation document?',
    pu: 'Confirmar a aprovação deste documento de confirmação?'
  },
  selectBillingPeriod: {
    zh: '请选择账期',
    en: 'Please select billing period',
    pu: 'Por favor, selecione o período de faturamento'
  },
  currentAddressInfo: {
    zh: '当前地址',
    en: 'Current Address Information',
    pu: 'Endereço Atual'
  },
  newAddressInfo: {
    zh: '新地址信息',
    en: 'New Address Information',
    pu: 'Novas Informações de Endereço'
  },
  verifyAddressValidity: {
    zh: '验证地址是否有效',
    en: 'Verify Address Validity',
    pu: 'Verificar Validade do Endereço'
  },
  newAddress: {
    zh: '新地址',
    en: 'New Address',
    pu: 'Novo Endereço'
  },
  longitude: {
    zh: '经度',
    en: 'Longitude',
    pu: 'Longitude'
  },
  latitude: {
    zh: '纬度',
    en: 'Latitude',
    pu: 'Latitude'
  },
  notifyReplaceWaybill: {
    zh: '请及时通知相关部门更换面单',
    en: 'Please notify relevant departments to replace the waybill in a timely manner',
    pu: 'Por favor, notifique os departamentos relevantes para substituir o romaneio em tempo hábil'
  },
  mapServiceNotInitialized: {
    zh: '地图服务未初始化',
    en: 'Map service not initialized',
    pu: 'Serviço de mapa não inicializado'
  },
  addressAutoFilled: {
    zh: '地址信息已自动回填',
    en: 'Address information auto-filled',
    pu: 'Informações de endereço preenchidas automaticamente'
  },
  enterSearchAddress: {
    zh: '请输入搜索地址',
    en: 'Please enter search address',
    pu: 'Por favor, insira o endereço de busca'
  },
  mapServiceNotReady: {
    zh: '地图服务尚未初始化完成',
    en: 'Map service not yet initialized',
    pu: 'Serviço de mapa ainda não inicializado'
  },
  noMatchingAddress: {
    zh: '未找到匹配的地址',
    en: 'No matching address found',
    pu: 'Nenhum endereço correspondente encontrado'
  },
  addressSearchFailed: {
    zh: '地址搜索失败，请稍后再试',
    en: 'Address search failed, please try again later',
    pu: 'Falha na busca de endereço, por favor tente novamente mais tarde'
  },
  damagedItems: {
    zh: '破损物品',
    en: 'Damaged Items',
    pu: 'Item danificado'
  },
  glass: {
    zh: '玻璃',
    en: 'Glass',
    pu: 'Vidro'
  },
  liquid: {
    zh: '液体',
    en: 'Liquid',
    pu: 'Líquido'
  },
  other: {
    zh: '其它',
    en: 'Other',
    pu: 'Outros'
  },
  newAddressSearch: {
    zh: '新地址搜索',
    en: 'New Address Search',
    pu: 'Busca de Novo Endereço'
  },
  enterFullAddressToSearch: {
    zh: '请输入完整地址后搜索',
    en: 'Please enter the complete address to search',
    pu: 'Por favor, insira o endereço completo para buscar'
  },
  addressSupplementOptional: {
    zh: '地址补充(选填)',
    en: 'Address Supplement (Optional)',
    pu: 'Complemento de Endereço (Opcional)'
  },
  addressSupplementExample: {
    zh: '如:靠近xxx小区大门, 门卫代收等',
    en: 'e.g., near xxx community gate, security guard collection, etc.',
    pu: 'Ex: perto do portão do condomínio xxx, recepção pelo porteiro, etc.'
  },
  supplementaryInfoNotice: {
    zh: '补充信息将展示给派送员, 帮助派送更顺利',
    en: 'Supplementary information will be shown to the courier to help delivery go more smoothly',
    pu: 'Informações complementares serão mostradas ao entregador para ajudar a entrega a ser mais tranquila'
  },
  confirmAddressChange: {
    zh: '确认修改地址',
    en: 'Confirm Address Change',
    pu: 'Confirmar Alteração de Endereço'
  },
  confirmAddressInfoNotice: {
    zh: '请确认以下地址信息是否正确，确认后将更新为新的派送地址。',
    en: 'Please confirm whether the following address information is correct. After confirmation, it will be updated as the new delivery address.',
    pu: 'Por favor, confirme se as seguintes informações de endereço estão corretas. Após a confirmação, serão atualizadas para o novo endereço de entrega.'
  },
  notifyReplaceWaybillNotice: {
    zh: '请及时通知相关部门更换面单，避免派送问题。',
    en: 'Please notify relevant departments to replace the waybill in time to avoid delivery issues.',
    pu: 'Por favor, notifique os departamentos relevantes para substituir o romaneio a tempo de evitar problemas de entrega.'
  },
  consolidation: {
    zh: '集包',
    en: 'Consolidation',
    pu: 'Consolidação'
  },
  printingWaybillPleaseWait: {
    zh: '正在打印面单，请稍候',
    en: 'Printing waybill, please wait',
    pu: 'Imprimindo romaneio, aguarde'
  },
  printFailed: {
    zh: '打印失败',
    en: 'Print Failed',
    pu: 'Falha na Impressão'
  },
  packageConfirmation: {
    zh: '包裹确认',
    en: 'Package Confirmation',
    pu: 'Confirmação de Pacote'
  },
  associatedPackageCount: {
    zh: '关联包裹数量',
    en: 'Associated Package Count',
    pu: 'Quantidade de Pacotes Associados'
  },
  packageWaybillNumber: {
    zh: '包裹运单号',
    en: 'Package Waybill Number',
    pu: 'Número do Romaneio do Pacote'
  },
  verifyPackageCountNotice: {
    zh: '请核对包裹数量, 确保每个包裹正确粘贴一张面单',
    en: 'Please verify the package count to ensure each package has one correctly attached waybill',
    pu: 'Por favor, verifique a quantidade de pacotes para garantir que cada pacote tenha um romaneio anexado corretamente'
  },
  cancelPrint: {
    zh: '取消打印',
    en: 'Cancel Print',
    pu: 'Cancelar Impressão'
  },
  manualFeedTable: {
    zh: '人工供包台',
    en: 'Manual Feed Table',
    pu: 'Mesa de Alimentação Manual'
  },
  automaticFeedTable: {
    zh: '自动供包台',
    en: 'Automatic Feed Table',
    pu: 'Mesa de Alimentação Automática'
  },
  inReturnNotIncludingOriginalD2D: {
    zh: '退件中(不包含原单退件D2D)',
    en: 'In Return (excluding Original Order Return D2D)',
    pu: 'Em Devolução (excluindo Devolução de Pedido Original D2D)'
  }
};
export { scripting };
